import { AxiosResponse } from "axios";

import {
  IDashboardCategoryValue,
  IDashboardDateRange,
  IDashboardKpiSet,
  IDashboardWardArchivedRank,
  IDashboardWardRank,
} from "../../@types/admin";
import { api } from "../api";

const BASE = "/Admin/Dashboard";

function buildParams(
  wardIds: number[],
  range: IDashboardDateRange
): URLSearchParams {
  const params = new URLSearchParams();
  params.append("From", range.startDate.toISOString());
  params.append("To", range.endDate.toISOString());
  wardIds.forEach((id) => params.append("WardIds", String(id)));
  return params;
}

export const adminDashboardService = {
  async getKpis(
    wardIds: number[],
    range: IDashboardDateRange
  ): Promise<AxiosResponse<IDashboardKpiSet>> {
    return api.get<IDashboardKpiSet>(`${BASE}/Kpis`, {
      params: buildParams(wardIds, range),
    });
  },

  async getActivePatientsPerWard(
    wardIds: number[],
    range: IDashboardDateRange
  ): Promise<AxiosResponse<IDashboardWardRank[]>> {
    return api.get<IDashboardWardRank[]>(`${BASE}/ActivePatientsPerWard`, {
      params: buildParams(wardIds, range),
    });
  },

  async getArchivedPatientsPerWard(
    wardIds: number[],
    range: IDashboardDateRange
  ): Promise<AxiosResponse<IDashboardWardArchivedRank[]>> {
    return api.get<IDashboardWardArchivedRank[]>(
      `${BASE}/ArchivedPatientsPerWard`,
      { params: buildParams(wardIds, range) }
    );
  },

  async getDeviceUsage(
    wardIds: number[],
    range: IDashboardDateRange
  ): Promise<AxiosResponse<IDashboardCategoryValue[]>> {
    return api.get<IDashboardCategoryValue[]>(`${BASE}/DeviceUsage`, {
      params: buildParams(wardIds, range),
    });
  },

  async getReferralSources(
    wardIds: number[],
    range: IDashboardDateRange
  ): Promise<AxiosResponse<IDashboardCategoryValue[]>> {
    return api.get<IDashboardCategoryValue[]>(`${BASE}/ReferralSources`, {
      params: buildParams(wardIds, range),
    });
  },

  async getPromResults(
    wardIds: number[],
    range: IDashboardDateRange
  ): Promise<AxiosResponse<IDashboardCategoryValue[]>> {
    return api.get<IDashboardCategoryValue[]>(`${BASE}/PromResults`, {
      params: buildParams(wardIds, range),
    });
  },
};
